import FormSectionTitle from '../../../elements/FormSectionTitle'
import CountrySelect from '../../../elements/Select/Country'
import { Button, Col, DatePicker, Form, Input } from 'antd'
import { defaultFormItemLayout, rules } from '../../../modules/FormItems'
import StatusSelect from '../../../elements/Select/Supplier/StatusSelect'
import { dateVal, strVal } from '../../../modules/Utils'
import React from 'react'
import { compose } from 'recompose'

function LenderDetailsForm (props) {
  const { submitting, lender, update } = props
  const { getFieldDecorator } = props.form
  return (
    <Form>
      <FormSectionTitle title={'Details'}/>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="Status">
          {getFieldDecorator('status', {
            initialValue: strVal(lender, 'status'),
            rules: rules.input,
          })(<StatusSelect/>)}
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="Location">
          {getFieldDecorator('location', {
            initialValue: strVal(lender, 'location'),
          })(<CountrySelect/>)}
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="Registration Date">
          <DatePicker
            disabled
            style={{ width: '100%' }}
            placeholder="Registration Date"
            value={dateVal(lender, 'date.registration')}
          />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="Tax Registration">
          {getFieldDecorator('taxRegistration', {
            initialValue: strVal(lender, 'taxRegistration'),
          })(<Input style={{ width: '100%' }} placeholder="Tax Registration"/>)}
        </Form.Item>
      </Col>

      <Button loading={submitting} type="primary" onClick={update} style={{ marginTop: 20 }}>
        Update
      </Button>
    </Form>
  )
}

export default compose(Form.create())(LenderDetailsForm)
